export const AUTH_CLEAR_ERROR = 'AUTH:CLEAR_ERROR';
export const AUTH_MAGIC_LINK_SET_CALLBACK_URL = 'AUTH:MAGIC_LINK_SET_CALLBACK_URL';
